import React from 'react'
import { Helmet } from 'react-helmet'
import TopNavigation from '../Components/navigation/TopNavigation'
import MainFooter from '../Components/footer/MainFooter'

function PrivacyPolicy() {
  return (
    <div className="main-layer">
      <Helmet>
              <title>Lovedripp - Privacy Policy </title>
      </Helmet>
      <TopNavigation title={"Terms and Conditions"} classBack="full-white"/>
       <div className="content-layer">
           <div className="section-item terms-pop">
                <div className="container">
                    <h6>Privacy Policy for Lovedripp</h6>
                    <p>Effective Date: 29/07/2025</p>
                    <p>Welcome to Lovedripp. Your privacy is important to us. This Privacy Policy explains how we collect, use, share, and protect your information when you use our platform, 
                       located at [www.lovedripp.co.za] (“Platform”), and any related services.</p>
                    <p>
                        By using Lovedripp, you agree to the practices described in this policy. If you do not agree, please do not use the Platform.
                    </p>
                    <h6>1. Information We Collect</h6>
                    <p>
                        a. Information You Provide
                    </p>
                    When you create an account or interact with the Platform, we collect the following:
                    <ul>
                        <li>Name, email address, phone number</li>
                        <li>Wedding or anniversary event details</li>
                        <li>Photos, guest lists, or other content you upload</li>
                        <li>Any messages you send through the Platform</li>
                    </ul>
                    <p>
                        b. Automatically Collected Information
                    </p>
                    We may automatically collect:
                    <ul>
                        <li>IP address</li>
                        <li>Device type and browser</li>
                        <li>Date/time of access</li>
                        <li>Usage activity (e.g. pages visited, clicks)</li>                        
                    </ul>
                    <h6>2. How We Use Your Information</h6>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Create and manage your account</li>
                        <li>Display your events and invitations</li>
                        <li>Communicate with you (e.g., confirmation emails, updates)</li>
                        <li>Improve the performance and user experience of the Platform</li>
                        <li>Enforce our Terms of Service and prevent abuse</li>
                    </ul>
                    <h6>How We Share Your Information</h6>
                    <p>We do not sell your personal information. We may share your information in the following situations:</p>
                    <ul>
                        <li>With your consent (e.g., when you share an invite publicly)</li>
                        <li>With service providers who help us operate the Platform (e.g., hosting, analytics)</li>
                        <li>When required by law (e.g., in response to court orders or legal processes)</li>
                        <li>To protect our rights or prevent harm</li>
                    </ul>
                    <h6>4. Cookies and Tracking</h6>
                    <p>We use cookies and similar technologies to improve your experience, such as:</p>
                    <ul>
                        <li>Keeping you signed in</li>
                        <li>Understanding how you use the Platform</li>
                        <li>Remembering your preferences</li>
                    </ul>
                    You can control cookies through your browser settings.
                    <h6>5. Data Security</h6>
                    <p>
                        We take reasonable steps to protect your personal information, including encryption, access controls, and secure hosting. However, no system is 100% secure, and we cannot guarantee the security of information transmitted over the internet.
                    </p>
                    <h6>6. Your Rights</h6>
                    <p>Depending on your location, you may have the right to:</p>
                    <ul>
                        <li>Access or request a copy of your personal data</li>
                        <li>Correct or delete your information</li>
                        <li>Object to or limit how we use your data</li>
                        <li>Withdraw your consent at any time</li>
                    </ul>
                    To make a request, contact us at <a href="mailto:privacy@lovedripp.co.za">privacy@lovedripp.co.za</a>
                    <h6>7. Children’s Privacy</h6>
                    <p>Lovedripp is not intended for use by children under the age of 13. We do not knowingly collect data from children. If we become aware of such collection, we will delete the data.</p>
                    <h6>8. Third-Party Links</h6>
                    <p>
                        Our Platform may contain links to third-party sites (e.g., social media). We are not responsible for the privacy practices or content of these external sites.
                    </p>
                    <h6>9. Changes to This Policy</h6>
                    <p>We may update this Privacy Policy from time to time. When we do, we will post the updated version on this page and update the effective date.</p>
                    <h6>10. Contact Us</h6>
                    <p>
                        For any questions about this Privacy Policy, or to exercise your privacy rights, contact us at:📧 <a href="mailto:privacy@lovedripp.co.za">privacy@lovedripp.co.za</a>
                    </p>
                </div>
            </div>
       </div>
       <MainFooter />
    </div>
  )
}

export default PrivacyPolicy